export default [
  {
    path: '/deviceManagement',
    name: 'deviceManagement',
    component: () => import(/* webpackChunkName: "deviceManagement" */ './index'),
    meta: {
      type: 'deviceManagement'
    },
    redirect: '/deviceManagement/deviceList',
    children: [
      {
        path: 'deviceList',
        component: () => import(/* webpackChunkName: "deviceManagement" */ './deviceList/'),
        redirect: '/deviceManagement/deviceList/index',
        children: [
          {
            path: 'index',
            name: 'deviceList',
            meta: {
              keepAlive: true
            },
            component: () => import(/* webpackChunkName: "deviceManagement" */ './deviceList/views')
          },
          {
            path: 'deviceListDetail/:sn/:model',
            name: 'deviceListDetail',
            component: () =>
              import(
                /* webpackChunkName: "deviceManagement" */ './deviceList/views/deviceListDetail'
              )
          },
          {
            path: 'deviceListLog/:sn/:model/:version',
            name: 'deviceListLog',
            component: () =>
              import(/* webpackChunkName: "deviceManagement" */ './deviceList/views/deviceListLog')
          },
          {
            path: 'deviceListTask/:sn/:model',
            name: 'deviceListTask',
            component: () =>
              import(/* webpackChunkName: "deviceManagement" */ './deviceList/views/deviceListTask')
          }
        ]
      },
      {
        path: 'deviceRoom',
        name: 'deviceRoom',
        component: () => import(/* webpackChunkName: "deviceManagement" */ './deviceRoom')
      },
      {
        path: 'deviceType',
        name: 'deviceType',
        component: () => import(/* webpackChunkName: "deviceManagement" */ './deviceType')
      },
      {
        path: 'activeDevice',
        name: 'activeDevice',
        component: () => import(/* webpackChunkName: "deviceManagement" */ './activeDevice')
      },
      {
        path: 'peripheralList',
        name: 'peripheralList',
        component: () => import(/* webpackChunkName: "deviceManagement" */ './peripheralList')
      }
    ]
  }
]
